/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_Add_Files_DescriptionInputs */

const en_files_add_files_description = /** @type {(inputs: Files_Add_Files_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick the files to add. Search to narrow the list.`)
};

const es_files_add_files_description = /** @type {(inputs: Files_Add_Files_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige los archivos que quieres agregar. Busca para acotar la lista.`)
};

/**
* | output |
* | --- |
* | "Pick the files to add. Search to narrow the list." |
*
* @param {Files_Add_Files_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_add_files_description = /** @type {((inputs?: Files_Add_Files_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Add_Files_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_add_files_description(inputs)
	return en_files_add_files_description(inputs)
});